import { render, staticRenderFns } from "./systemTheme.vue?vue&type=template&id=2600fe13"
import script from "./systemTheme.vue?vue&type=script&lang=js"
export * from "./systemTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports